// eslint-disable-next-line import/prefer-default-export
export { default as SearchResults } from './search-results';



// WEBPACK FOOTER //
// ./node_modules/cigna_csg_gsg_elasticsearch/src/js/index.js